import React, { useState } from 'react';

import { AccountControlsMobileLayoutComponent } from 'design/accountControlsMobileLayout';
import { useAccountEmail } from 'hooks/useAccountEmail';
import { TextComponent } from 'design/text/textComponents';
import { ClickControlComponent } from 'design/clickControl/clickControlComponents';
import { useHistory } from 'react-router';
import { routes } from 'utils/routes';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { ProfileIcon } from 'svg/24x24/profile';

type Props = { redirectOnSignedOutTo?: string };

export const AccountControlsMobile = (props: Props) => {
  const { redirectOnSignedOutTo } = props;

  const history = useHistory();

  const disctionary = useIntlDictionary();

  const [hasMenu, setHasMenu] = useState(false);

  const signOut = React.useCallback(() => {
    history.push(routes.signOut({ redirect: redirectOnSignedOutTo }));
  }, [history, redirectOnSignedOutTo]);

  const goToRoot = React.useCallback(() => {
    history.push('/');
  }, [history]);

  const email = useAccountEmail();

  if (!email) {
    return null;
  }

  return (
    <>
      <ClickControlComponent onClick={() => setHasMenu(true)}>
        <TextComponent color="primary">
          <ProfileIcon />
        </TextComponent>
      </ClickControlComponent>
      {hasMenu && (
        <AccountControlsMobileLayoutComponent
          onOutsideClick={() => setHasMenu(false)}
          email={
            <ClickControlComponent onClick={goToRoot}>
              <TextComponent>{email}</TextComponent>
            </ClickControlComponent>
          }
          signOutAction={
            <ClickControlComponent onClick={signOut}>
              <TextComponent>{disctionary.logOutButton}</TextComponent>
            </ClickControlComponent>
          }
        />
      )}
    </>
  );
};
